import { get, put } from './';

export const getOrganizationTheme = ({ organizationId }) =>
  get(`/api/v1/organizations/${organizationId}/theme`);

export const updateOrganizationTheme = (organizationId, payload) =>
  put(`/api/v1/organizations/${organizationId}/theme`, payload);
